import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    contentType: '',
    contentName: '',
    menuViews: null,
    subjects: '',
    htmlText: '',
    menuDatas: null,
    nodepath: '',
    docType: '',
    video: '',
    folderName: '',
    tabName: '',
    url: ''
};

// createSlice를 사용하여 slice 생성
const contentSlice = createSlice({
    name: 'content',
    initialState,
    reducers: {
        setContentInfo: (state, action) => {
            state.contentType = action.payload.contentType;
            state.contentName = action.payload.contentName;
            state.docType = action.payload.type;
            state.video = action.payload.video;
            state.folderName = action.payload.folderName;
            state.tabName = action.payload.tabName;
            state.url = action.payload.url;
        },
        initMenu: (state) => {
            state.menuDatas = null;
            state.menuViews = null;
        },
        setMenu: (state, action) => {
            const strJson = JSON.stringify(action.payload.treeData);
            state.menuDatas = JSON.parse(strJson);
            state.menuViews = action.payload.treeView;
        },
        setContent: (state, action) => {
            state.htmlText = action.payload;
        },
        setPath: (state, action) => {
            state.nodepath = action.payload;
        },
        init: () => initialState
    }
});

export const { setContentInfo, initMenu, setMenu, setContent, setPath, init } = contentSlice.actions;
export default contentSlice.reducer;
